export default __webpack_public_path__ + "static/remoni-4ba270425598e8fd8f1d59acbc35165a.svg";